import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LinkItem, StyleType} from "@catui/types";
import {ModifyNetworkIfComponent} from "@catmodules/models/network-interfaces/components/modify-network-if/modify-network-if.component";
import {ModalService} from "@catmodules/widgets/slide-in-modal/services/modal.service";
import {GenericLinkedResource} from "@catcore/types/base";
import {isNullOrUndefined} from "util";
import {Subscription} from "rxjs/Subscription";
import {extractDataFromModel, genericResourceToLinkItem} from "@catcore/utils";
import {Router} from "@angular/router";
import {ProjectUnit} from "@catmodules/models/project-units/types";
import {NetworkInterface} from "@catmodules/models/network-interfaces/types";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";

@Component({
  selector: 'cat-network-if-list',
  templateUrl: './network-if-list.component.html',
  styleUrls: ['./network-if-list.component.scss']
})
export class NetworkIfListComponent implements OnInit {

  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<NetworkInterface>();

  @Input()
  featureLevel = false;

  linkedNetworkInterfaces: LinkItem[] = [];
  modalResourceSubscription: Subscription;

  styleType = StyleType;

  private _unit: any;

  @Input()
  set unit(value) {
    this._unit = value;
    if (this._unit) {
      const networkInterfaces = extractDataFromModel<ProjectUnit>(this._unit, 'network_interfaces');
      this.linkedNetworkInterfaces = genericResourceToLinkItem(networkInterfaces, (value: GenericLinkedResource) => (router: Router) => this.openModifyNetworkInterfaceDialog(value));
      this.linkedNetworkInterfaces.sort((a,b) => {return (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0);});
    }
  }

  constructor(private modalService: ModalService,
              private genericService: GenericResourceService,) { }

  ngOnInit() {
  }

  openModalForNewNetworkInterface() {
    const compRef = this.modalService.open(ModifyNetworkIfComponent);
    compRef.componentInstance.enableDelete = false;
    compRef.componentInstance.featureLevel = this.featureLevel;
    compRef.componentInstance.unitUri = this._unit._links.self.href;
    compRef.componentInstance.afterUpdate.subscribe((updatedNetworkIf) => this.afterUpdate.emit(updatedNetworkIf));
    return compRef;
  }

  private openModifyNetworkInterfaceDialog(networkInterface: GenericLinkedResource) {
    this.openDialog(networkInterface, (unit) => this.networkInterfaceModalFactory(unit));
  }

  private networkInterfaceModalFactory(networkIfEntity) {
    const compRef = this.modalService.open(ModifyNetworkIfComponent);
    compRef.componentInstance.networkIf = networkIfEntity;
    compRef.componentInstance.enableDelete = true;
    compRef.componentInstance.featureLevel = this.featureLevel;
    compRef.componentInstance.afterUpdate.subscribe((updatedNetworkIf) => this.afterUpdate.emit(updatedNetworkIf));
    compRef.componentInstance.afterDelete.subscribe(() => this.afterDelete.emit());
    return compRef;
  }

  private openDialog(resource: GenericLinkedResource, componentFactory) {
    let compRef;
    const onFullfill = () => {
      resourceHandler.refresh();
      this.modalResourceSubscription.unsubscribe();
    };

    const onError = () => {
      this.modalResourceSubscription.unsubscribe();
    };

    const resourceHandler = this
      .genericService
      .findServiceForResource(resource.href);

    this.modalResourceSubscription = resourceHandler
      .getCurrent()
      .subscribe((item) => {
        if (compRef) {
          compRef.close();
          compRef = null;
        }

        if (isNullOrUndefined(item)) {
          compRef = null;
        } else {
          compRef = componentFactory(item);
          compRef.result.then(onFullfill, onError);
        }
      });

    if (!resourceHandler.isReady()) {
      resourceHandler.load();
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/network-interfaces/components/network-if-list/network-if-list.component.ts